import { RoutePath } from 'enums/routePath';

export const ADMIN_365_SETUP = '/admin-365-setup';
export const SETTINGS_INTEGRATION_365_AUTH =
  '/settings/integration/office365/auth';
export const SETTINGS_IMPORT_CONTACTS = '/settings/import/contacts';
export const SETTINGS_IMPORT_CONTACTS_INITIALSTEP =
  '/settings/import/contacts/:initialStep/';
export const SETTING_BILLING_SUBSCRIBE = '/settings/billing/subscribe';
export const SETTING_BILLING_UPDATE = '/settings/billing/update';
export const CHANGE_PASSWORD = '/change-password';
export const CHANGE_PASSWORD_DONE = '/change-password/done';
export const GET_IN_TOUCH = '/get-in-touch';
export const GET_IN_TOUCH_DONE = '/get-in-touch/sent';

export const modalLayoutPaths = {
  [RoutePath.ADMIN_365_SETUP]: ADMIN_365_SETUP,
  [RoutePath.SETTINGS_INTEGRATION_365_AUTH]: SETTINGS_INTEGRATION_365_AUTH,
  [RoutePath.SETTINGS_IMPORT_CONTACTS]: SETTINGS_IMPORT_CONTACTS,
  [RoutePath.SETTINGS_IMPORT_CONTACTS_INITIALSTEP]:
    SETTINGS_IMPORT_CONTACTS_INITIALSTEP,
  [RoutePath.SETTING_BILLING_SUBSCRIBE]: SETTING_BILLING_SUBSCRIBE,
  [RoutePath.SETTING_BILLING_UPDATE]: SETTING_BILLING_UPDATE,
  [RoutePath.CHANGE_PASSWORD]: CHANGE_PASSWORD,
  [RoutePath.CHANGE_PASSWORD_DONE]: CHANGE_PASSWORD_DONE,
  [RoutePath.GET_IN_TOUCH]: GET_IN_TOUCH,
  [RoutePath.GET_IN_TOUCH_DONE]: GET_IN_TOUCH_DONE,
};

export const pathArray = Object.values(modalLayoutPaths);

export default modalLayoutPaths;
